import { Box, Button, SxProps, Theme } from '@mui/material';

// Shared by every module pricing landing (Plannings, Tareas asignadas): the
// "know the plans" / "talk to sales" button pair. Extracted so a style or
// testid fix lands once instead of being copy-pasted per landing.
const customStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginTop: '20px',
  },
  ctaButton: {
    backgroundColor: '#3e8ffa',
    borderRadius: '18px',
    padding: '8px 18px',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    textTransform: 'none',
    '&:hover': { backgroundColor: '#2d7fe8' },
  },
  salesButton: {
    borderRadius: '16px',
    padding: '8px 16px',
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    color: '#4760f6',
    textTransform: 'none',
    '&:hover': { backgroundColor: 'rgba(71, 96, 246, 0.08)' },
  },
} satisfies Record<string, SxProps<Theme>>;

interface Props {
  knowPlansLabel: string;
  contactSalesLabel: string;
  onKnowPlans: () => void;
  onContactSales: () => void;
}

export function PricingCTAButtons({
  knowPlansLabel,
  contactSalesLabel,
  onKnowPlans,
  onContactSales,
}: Props) {
  return (
    <Box sx={customStyles.container}>
      <Button
        variant='contained'
        onClick={onKnowPlans}
        sx={customStyles.ctaButton}
        data-testid='know-plans'
      >
        {knowPlansLabel}
      </Button>
      <Button
        variant='text'
        onClick={onContactSales}
        sx={customStyles.salesButton}
        data-testid='contact-sales'
      >
        {contactSalesLabel}
      </Button>
    </Box>
  );
}
